import { C as CosmosTitle$1, d as defineCustomElement$1 } from './p-5f825a71.js';

const CosmosTitle = CosmosTitle$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosTitle, defineCustomElement };
